import React, { useState, useEffect } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import { LocationFormProps, LocationUpdateFormData, LocationUpdatePageProps } from './types';
import { LocationUpdateFormRenderComponent } from './LocationUpdateFormRenderComponent';

import { validateLocationForm } from '../validation';

export const LocationUpdatePage: React.FC<LocationUpdatePageProps> = ({
  isInitiallyLoading,
  locationUpdate,
  initialValues,
  location,
  disconnectMobile,
  disconnectLoyalty,
  canDisconnect,
  isDisconnectMobileOrLoyaltyInProgress,
}) => {
  const [currentValues, setCurrentValues] = useState(initialValues);

  useEffect(() => {
    setCurrentValues(initialValues);
  }, [isInitiallyLoading, initialValues]);

  const renderForm: LocationFormProps['render'] = React.useCallback(
    ({
      handleSubmit,
      valid,
      error,
      dirty,
      pristine,
      dirtySinceLastSubmit,
      modifiedSinceLastSubmit,
      submitSucceeded,
    }: FormRenderProps<LocationUpdateFormData>) => {
      return (
        <LocationUpdateFormRenderComponent
          isInitiallyLoading={isInitiallyLoading}
          valid={valid}
          handleSubmit={handleSubmit}
          error={error}
          dirty={dirty}
          pristine={pristine}
          dirtySinceLastSubmit={dirtySinceLastSubmit}
          modifiedSinceLastSubmit={modifiedSinceLastSubmit}
          submitSucceeded={submitSucceeded}
          location={location}
          disconnectMobile={disconnectMobile}
          disconnectLoyalty={disconnectLoyalty}
          canDisconnect={canDisconnect}
          isDisconnectSiteInProgress={isDisconnectMobileOrLoyaltyInProgress}
        />
      );
    },
    [
      isInitiallyLoading,
      location,
      disconnectMobile,
      disconnectLoyalty,
      canDisconnect,
      isDisconnectMobileOrLoyaltyInProgress,
    ],
  );

  return (
    <Form<LocationUpdateFormData>
      onSubmit={locationUpdate}
      keepDirtyOnReinitialize={true}
      render={renderForm}
      initialValues={currentValues}
      validate={validateLocationForm}
      mutators={{ ...arrayMutators }}
    />
  );
};

export default LocationUpdatePage;
